import React from 'react';

import { TReportStatus } from '@entities/financeExportReport';
import { Icon, Spinner } from '@shared/ui';

interface ReportStatusIconProps {
    status: TReportStatus;
}

export const ReportStatusIcon = ({ status }: ReportStatusIconProps) => {
    if (status === 'new' || status === 'in_progress') {
        return <Spinner width={16} height={16} />;
    }

    if (status === 'failed') {
        return <Icon iconName="isErrorClose" width={16} height={16} />;
    }

    return <Icon iconName="isChecked" width={16} height={16} />;
};
